import React from 'react'
import { Nav, NavItem } from 'react-bootstrap'
import { Route, Switch, Redirect } from 'react-router-dom'
import { connect } from 'react-redux';
import StringUtil from '@leverege/string-util'
import { Dialogs } from '@leverege/ui-elements'
import PatchOps from '@leverege/api-patch-ops'
import RouteMatcher from '~/RouteMatcher'

import TemplateInfoScreen from './TemplateInfoScreen'

import { View } from '~/views';
import TemplateDataScreen from './TemplateDataScreen';
import { TemplateActions } from '../../actions';
import AddIntentDialog from './AddIntentDialog';

class TemplateHomeScreen extends React.Component {

  static getRoutes( template ) {
    const intents = template?.intents || {}

    return [
      <Route
        key="/project/:projectId/template/:templateId"
        path="/project/:projectId/template/:templateId"
        exact
        component={TemplateInfoScreen} />,
      <Route
        key="/project/:projectId/template/:templateId/"
        path="/project/:projectId/template/:templateId/"
        exact
        component={TemplateInfoScreen} />,
      <Route
        key="/project/:projectId/template/:templateId/info"
        path="/project/:projectId/template/:templateId/info"
        exact={false}
        component={TemplateInfoScreen} />,
      ...Object.entries( intents ).reduce( ( prev, [ intentType, intent ] ) => {
        prev.push(
          <Route
            key={`/project/:projectId/template/:templateId/${intentType}`}
            path={`/project/:projectId/template/:templateId/${intentType}`}
            exact={false}
            render={( props ) => {
              return <TemplateDataScreen {...props} intentType={intentType} showSubject={intent.subject != null} />
            }} />
        )

        return prev
      }, [] ),
      <Redirect
        key="/project/:projectId/template/:templateId/info"
        to="/project/:projectId/template/:templateId/info" />
    ]
  }

  constructor( props ) {
    super( props );
    const { template } = props

    this.routeMatcher = new RouteMatcher( TemplateHomeScreen.getRoutes( template ), { missComponent : null } )
  }

  componentDidMount() {
    const { projectId, templateId } = this.props.match.params
    
    this.props.dispatch( TemplateActions.get( projectId, templateId ) )
  }

  componentDidUpdate( prevProps ) {
    const { template } = this.props
    const { template : pTemplate } = prevProps

    if ( template !== pTemplate ) {
      this.routeMatcher = new RouteMatcher( TemplateHomeScreen.getRoutes( template ), { missComponent : null } )
    }
  }

  onAddIntent = ( { intentKey, hasSubject } ) => {
    const { dispatch, match : { params : { projectId, templateId } }, history } = this.props

    const patchOps = PatchOps().add( `intents/${intentKey}`, {
      subject : hasSubject ? '' : undefined,
      data : '',
      dataType : 'hbs'
    } ).ops()

    dispatch( TemplateActions.update( projectId, templateId, patchOps ) )
      .then( ( err ) => {
        if ( !err ) {
          history.push( `/project/${projectId}/template/${templateId}/${intentKey}` )
        }
      } )
  }

  onTabSelected = ( key, evt ) => {
    const { template } = this.props
    
    if ( key === 'addIntent' ) {
      Dialogs.show( {
        component : AddIntentDialog,
        props : {
          onAddIntent : this.onAddIntent,
          template
        }
      } )

      return
    }
    const { history } = this.props
    const { projectId, templateId } = this.props.match.params
    history.push( `/project/${projectId}/template/${templateId}/${key}` )
  }

  render() {
    const { location, template } = this.props
    const matchResult = this.routeMatcher.find( location )

    const activeKey = getLastURLSegment( matchResult.match?.path )
    const intents = template?.intents || {}

    return ( 
      <View style={{ display : 'flex', flexDirection : 'column', overflow : 'hidden' }}>
        <Nav bsStyle="tabs" activeKey={activeKey} onSelect={this.onTabSelected}>
          <NavItem eventKey="info">Info</NavItem>
          {Object.keys( intents ).map( ( intentType ) => {
            return <NavItem eventKey={intentType}>{StringUtil.capitalize( intentType )}</NavItem>
          } )}
          <NavItem eventKey="addIntent"><i className="fa fa-fw fa-plus" />Add Intent</NavItem>
        </Nav>

        <div style={{ flex : 1, overflow : 'auto', position : 'relative' }}>
          <Switch>
            {TemplateHomeScreen.getRoutes( template )}
          </Switch>
        </div>
      </View>
    )
  }
}

function getLastURLSegment( url ) {
  if ( !url ) {
    return ''
  }

  return url.split( '/' ).at( -1 )
}

export default connect(
  ( state, props ) => ( {
    template : state.templates.lookup[props.match.params.templateId]
  } )
)( TemplateHomeScreen )
